<template>
  <div>
    <i-box class="dashboard-unit" :style="{ height: height }">
      <span class="unit-title" slot="title">
        <div class="pull-left">
          <span :class="titleIconClass"></span>
          <span>{{ title }}</span>
        </div>
        <div class="pull-right">
          <el-tooltip :content="titleRightIcon.tooltip" placement="top">
            <span v-on:click="rightIconClick" :class="titleRightIcon.icon"></span>
          </el-tooltip>
        </div>
      </span>
      <span class="unit-content" slot="content">
        <slot name="unit-content"></slot>
      </span>
    </i-box>
  </div>
</template>

<script>
import IBox from '@/components/common/IBox';

export default {
  name: 'ProgrammingDashboardUnit',
  components: {
    IBox,
  },
  props: {
    title: {
      type: String,
      required: true,
    },

    titleIconClass: {
      type: String,
      default: '',
    },

    height: {
      type: String,
      default: null,
    },

    titleRightIcon: {
      type: Object,
      default: () => ({ tooltip: '', icon: '' }),
    },
  },
  methods: {
    rightIconClick() {
      this.$emit('unitRightIconClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';

.dashboard-unit {
  background-color: white !important;
}

// .unit-content {
//   height: 260px;
//   overflow: hidden;
//   overflow-y: scroll;
//   display: block;
// }

.unit-title {
  font-size: 1.1em;
  font-weight: bolder;
  color: $colony-purple;
}
</style>



// WEBPACK FOOTER //
// ProgrammingDashboardUnit.vue?7c56c708